import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { CATEGORIES } from "@/lib/categories";

const FIRMA_LINKS = [
  { to: "/historia", label: "Nuestra historia" },
  { to: "/herramientas", label: "Herramientas" },
  { to: "/precalificacion", label: "Precalificación" },
];

const FooterColumn = ({ title, children }) => (
  <>
    <div className="eyebrow text-white/40">{title}</div>
    <ul className="mt-6 space-y-3">{children}</ul>
  </>
);

const FooterLink = ({ to, children }) => (
  <li>
    <Link
      to={to}
      className="font-sans text-sm text-white/80 hover:text-razmek-gold transition-colors"
    >
      {children}
    </Link>
  </li>
);

const ContactRow = ({ label, value, href, external = false }) => (
  <li>
    <div className="font-sans text-[11px] tracking-[0.2em] uppercase text-white/40">
      {label}
    </div>
    {href ? (
      <a
        href={href}
        {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
        className="font-sans text-base text-white hover:text-razmek-gold transition-colors"
      >
        {value}
      </a>
    ) : (
      <div className="font-sans text-base text-white">{value}</div>
    )}
  </li>
);

const BrandColumn = () => (
  <div className="lg:col-span-4">
    <Logo variant="dark" />
    <p className="mt-8 font-sans text-sm leading-relaxed text-white/60 max-w-sm">
      Firma independiente de asesoría patrimonial. Construimos estrategias de
      protección, ahorro e inversión calibradas al proyecto de vida de cada
      cliente.
    </p>
  </div>
);

const BottomBar = () => (
  <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
    <p className="font-sans text-xs text-white/40">
      © {new Date().getFullYear()} RAZMEK Seguros e Inversiones. Todos los
      derechos reservados.
    </p>
    <div className="flex gap-6">
      <a href="#" className="font-sans text-xs text-white/40 hover:text-razmek-gold transition-colors">
        Aviso de privacidad
      </a>
      <a href="#" className="font-sans text-xs text-white/40 hover:text-razmek-gold transition-colors">
        Términos
      </a>
    </div>
  </div>
);

const Footer = () => (
  <footer className="bg-razmek-dark text-white relative overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <BrandColumn />

        <div className="lg:col-span-3">
          <FooterColumn title="Qué protegemos">
            {CATEGORIES.map((c) => (
              <FooterLink key={c.slug} to={`/proteger/${c.slug}`}>
                {c.label}
              </FooterLink>
            ))}
          </FooterColumn>
        </div>

        <div className="lg:col-span-2">
          <FooterColumn title="Firma">
            {FIRMA_LINKS.map((l) => (
              <FooterLink key={l.to} to={l.to}>
                {l.label}
              </FooterLink>
            ))}
          </FooterColumn>
        </div>

        <div className="lg:col-span-3">
          <div className="eyebrow text-white/40">Contacto</div>
          <ul className="mt-6 space-y-4">
            <ContactRow
              label="WhatsApp"
              value="+52 1 55 8357 0588"
              href="https://wa.me/5215583570588?text=Hola%20RAZMEK%2C%20me%20interesa%20una%20asesor%C3%ADa"
              external
            />
            <ContactRow
              label="Correo"
              value="contacto@razmek.com"
              href="mailto:contacto@razmek.com"
            />
            <ContactRow label="Atención" value="Lun – Vie · 09:00 – 19:00" />
          </ul>
        </div>
      </div>

      <BottomBar />
    </div>
  </footer>
);

export default Footer;
